export default __webpack_public_path__ + "static/media/default-pot-medium.b3988293.jpg";